import React, { Component } from 'react';
import './Tilte.css'

export default class Tilte extends Component {
  render() {
    return (
      <div className="mainTitle">
          <h2>{this.props.title}</h2>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/title/Tilte.js